<template>
    <sub-frame title="批量计费">
        <mt-field label="开始日期" placeholder="选择日期" type="date" v-model="dateStart"></mt-field>
        <mt-field label="截止日期" placeholder="选择日期" type="date" v-model="dateEnd"></mt-field>
        <mt-radio
                v-model="origin"
                :options="origins">
        </mt-radio>
        <mt-button type="primary" class="btn" @click="exec" v-if="origins.length">批量计费</mt-button>
    </sub-frame>
</template>

<script>
    export default {
        name: "ApplyPay",
        data() {
            return {
                dateStart: '',
                dateEnd: '',
                origin: '',
                origins: [
                ]
            }
        },
        created() {
            this.getOrigins();
        },
        methods: {
            async getOrigins() {
                let res = await this.$axios.get(`/applycheck/PartnerList`);
                this.origins = res.data;
            },
            async exec() {
                if (!this.dateStart) return this.$toast('请选择开始日期');
                if (!this.dateEnd) return this.$toast('请选择截止日期');
                if (!this.origin) return this.$toast('请选择订单来源');
                await this.$axios.post(`applypay`, {
                    dateStart: this.dateStart,
                    dateEnd: this.dateEnd,
                    partnerGuid: this.origin,
                });
                this.$toast('计费成功');
            }
        }
    }
</script>

<style scoped>
    .btn {
        width: calc(100% - 20px);
        margin: 15px 10px 0 ;
    }
</style>